import React, { useState, useEffect, useContext } from "react";
import ProductsGrid from "./ProductsGrid";
import ProductList from "./ProductList";
import { useMediaQuery } from "@material-ui/core";
import { breakpoints } from "@constants/styled-components";
import { addToCart } from "@actions/cart/addToCart";
import { addItemInShoppingList } from "@actions/shoppingList/addItemsToShoppingList";
import { useDispatch, useSelector } from "react-redux";
import AddItemToCart from "@pages/Cart/ShoppingCart/AddItemToCart";
import AddItemToShoppingList from "@pages/shoppingList/AddItemToShoppingList";
import {
  fetchProducts,
  filterProducts,
  CurrentSearchString,
  FetchFilterValues,
  fetchUpdatedParams,
  currentPage,
  productsSelector,
} from "@slices/Products/productSearch";
import { filterChipsSelector } from "@slices/Products/filterChipsReducer";
import { useGetLoggedInUserInfo } from "@hooks";
import { WebSettingsContext } from "@providers/WebsettingsProvider";
import ProductSortContainer from "./ProductSortContainer";
import FilterChips from "@fragments/FilterChips";
import {
  filterCatalog,
  fetchCatalogProducts,
  catalogSelector,
  fetchUpdatedParamsCatalog,
} from "@slices/Catalog/getCatalogData";
import LoadingOverlay from "@common/LoadingOverlay";
interface IProps {
  compareItems: any;
  totalItems: number;
  products: any;
  loading: boolean;
  hasErrors: boolean;
  pageNo: number;
  //setPage: Function;
  onFilterChange: Function;
  updateCompareListItems: Function;
  catalog: boolean;
  bannerImage: any;
  catalogDetails: any;
  catId: any;
  elementId: any;
  setshowFilter: Function;
  setListView: any;
  listView: any;
  updateDataValue: Function;
  sortValue: string;
  setSortValue: Function;
  page: string
}

const MainContent = (props: IProps) => {
  const dispatch = useDispatch();
  const [showAddToCart, setShowAddToCart] = useState<boolean>(false);
  const sessionId = useGetLoggedInUserInfo();
  const webSettingsData: any = useContext(WebSettingsContext);
  var searchString = useSelector(CurrentSearchString);
  const [loader, setLoader] = useState(false);
  const showPaginationComponent = useMediaQuery(
    `(min-width:${breakpoints.md})`
  );
  useEffect(() => {
    if (searchString.isCompleted) {
      setLoader(false);
    }
  }, [searchString.isCompleted]);

  const [productList, setProductList] = useState(
    props.products?.map((item: any) => {
      const catSalesUnit = item?.salesUnit
        ? item?.salesUnit
        : item?.defaultSalesUnit;
      const searchSalesUnit = item?.salesUnit
        ? item?.salesUnit
        : item?.itemUnitCode;
      const unit = props.catalog ? catSalesUnit : searchSalesUnit;
      if (
        item?.itemNumberOfDecimalsAllowed !== null &&
        item?.itemNumberOfDecimalsAllowed !== undefined &&
        item?.salesUnits !== null &&
        item?.salesUnits !== undefined &&
        unit !== null &&
        unit !== undefined &&
        Number(item?.itemNumberOfDecimalsAllowed?.length) > Number(0) &&
        Number(item?.salesUnits?.length) > Number(0)
      ) {
        return {
          key: !props.catalog ? item?.solrItemCode : item?.code,
          quantity: Number(1),
          unit: unit,
          isCartDisable: false,
          itemNumberOfDecimalsAllowed:
            item?.itemNumberOfDecimalsAllowed[item?.salesUnits?.indexOf(unit)],
        };
      } else
        return {
          key: !props.catalog ? item?.solrItemCode : item?.code,
          quantity: Number(1),
          unit: unit,
          isCartDisable: false,
          //itemNumberOfDecimalsAllowed:0
        };
    })
  );

  const quantityChangeHandler = (
    qty: number,
    index: number,
    isValid: boolean
  ) => {
    setProductList((prevState: any) => {
      const copyShowUnit = prevState ? [...prevState] : [{}];
      copyShowUnit[index] = {
        ...copyShowUnit[index],
        quantity: Number(qty),
        isCartDisable: !isValid,
      };
      return copyShowUnit;
    });
  };

  const [singleItemCalled, setSingleItemCalled] = useState<boolean>(false);
  const unitChangeHandler = (
    itemCode: string,
    selectedUnit: string,
    index: number,
    isCatalog: boolean
  ) => {
    const product = props?.products?.find((item: any) => {
      const code = !props.catalog ? item?.solrItemCode : item?.code;
      return code === itemCode;
    });
    if (
      product?.itemNumberOfDecimalsAllowed !== null &&
      product?.itemNumberOfDecimalsAllowed !== undefined &&
      product?.salesUnits !== null &&
      product?.salesUnits !== undefined &&
      selectedUnit !== null &&
      selectedUnit !== undefined &&
      Number(product?.itemNumberOfDecimalsAllowed?.length) > Number(0) &&
      Number(product?.salesUnits?.length) > Number(0)
    ) {
      setProductList((prevState: any) => {
        const copyShowUnit = prevState ? [...prevState] : [{}];
        copyShowUnit[index] = {
          ...copyShowUnit[index],
          unit: selectedUnit,
          quantity: 1,
          itemNumberOfDecimalsAllowed:
            product?.itemNumberOfDecimalsAllowed[
              product?.salesUnits?.indexOf(selectedUnit)
            ],
        };
        return copyShowUnit;
      });
    } else {
      setProductList((prevState: any) => {
        const copyShowUnit = prevState ? [...prevState] : [{}];
        copyShowUnit[index] = {
          ...copyShowUnit[index],
          unit: selectedUnit,
          itemNumberOfDecimalsAllowed: 0,
        };
        return copyShowUnit;
      });
    }

    if (!isCatalog) {
      setSingleItemCalled(true);
      dispatch(
        fetchUpdatedParams(encodeURIComponent(itemCode), sessionId?.sessionId, selectedUnit, index)
      );
    } else {
      setSingleItemCalled(true);
      dispatch(
        fetchUpdatedParamsCatalog(
          encodeURIComponent(itemCode),
          sessionId?.sessionId,
          selectedUnit,
          index
        )
      );
    }
  };

  useEffect(() => {
    setProductList(
      props.products?.map((item: any) => {
        const catSalesUnit = item?.salesUnit
          ? item?.salesUnit
          : item?.defaultSalesUnit;
        const searchSalesUnit = item?.salesUnit
          ? item?.salesUnit
          : item?.itemUnitCode;
        const unit = props.catalog ? catSalesUnit : searchSalesUnit;
        if (
          item?.itemNumberOfDecimalsAllowed !== null &&
          item?.itemNumberOfDecimalsAllowed !== undefined &&
          item?.salesUnits !== null &&
          item?.salesUnits !== undefined &&
          unit !== null &&
          unit !== undefined &&
          Number(item?.itemNumberOfDecimalsAllowed?.length) > Number(0) &&
          Number(item?.salesUnits?.length) > Number(0)
        ) {
          return {
            key: !props.catalog ? item?.solrItemCode : item?.code,
            quantity: Number(1),
            unit: unit,
            isCartDisable: false,
            itemNumberOfDecimalsAllowed:
              item?.itemNumberOfDecimalsAllowed[
                item?.salesUnits?.indexOf(unit)
              ],
          };
        } else
          return {
            key: !props.catalog ? item?.solrItemCode : item?.code,
            quantity: Number(1),
            unit: unit,
            isCartDisable: false,
            // itemNumberOfDecimalsAllowed:0,
          };
      })
    );
  }, [props?.products, singleItemCalled]);
  useEffect(() => {
    setProductList(
      props.products?.map((item: any) => {
        const catSalesUnit = item?.salesUnit
          ? item?.salesUnit
          : item?.defaultSalesUnit;
        const searchSalesUnit = item?.salesUnit
          ? item?.salesUnit
          : item?.itemUnitCode;
        const unit = props.catalog ? catSalesUnit : searchSalesUnit;
        if (
          item?.itemNumberOfDecimalsAllowed !== null &&
          item?.itemNumberOfDecimalsAllowed !== undefined &&
          item?.salesUnits !== null &&
          item?.salesUnits !== undefined &&
          unit !== null &&
          unit !== undefined &&
          Number(item?.itemNumberOfDecimalsAllowed?.length) > Number(0) &&
          Number(item?.salesUnits?.length) > Number(0)
        ) {
          return {
            key: !props.catalog ? item?.solrItemCode : item?.code,
            quantity: Number(1),
            unit: unit,
            isCartDisable: false,
            itemNumberOfDecimalsAllowed:
              item?.itemNumberOfDecimalsAllowed[
                item?.salesUnits?.indexOf(unit)
              ],
          };
        } else
          return {
            key: !props.catalog ? item?.solrItemCode : item?.code,
            quantity: Number(1),
            unit: unit,
            isCartDisable: false,
            // itemNumberOfDecimalsAllowed:0,
          };
      })
    );
  }, [searchString?.string]);

  const addItemToCartHandler = (
    sessionId: any,
    itemCode: string,
    quantity: number,
    unit: string
  ) => {
    const itemDataToDispatch = {
      itemCode: itemCode,
      itemQty: quantity,
      unitCode: unit,
      page: props.page,
    };

    dispatch(addToCart(sessionId, itemDataToDispatch));
    setShowAddToCart(true);
  };

  const addItemToShoppingListHandler = (
    sessionId: any,
    itemCode: string,
    quantity: number,
    unit: string
  ) => {
    const itemDataToDispatch = [
      {
        itemCode: itemCode,
        unitCode: unit,
        quantity: quantity,
      },
    ];
    dispatch(addItemInShoppingList(sessionId?.sessionId, itemDataToDispatch));
  };

  return (
    <React.Fragment>
      <LoadingOverlay active={loader} />
      <div className="container-fluid pr-0 pl-0">
        <div className="row">
          <div className="col-lg-12 pr-0 pl-0">
            <ProductSortContainer
              setListView={props.setListView}
              listView={props.listView}
              compareItems={props.compareItems}
              bannerImage={props.bannerImage}
              catalog={props.catalog}
              catId={props.catId}
              elementId={props.elementId}
              setshowFilter={props.setshowFilter}
              sortValue={props.sortValue}
              setSortValue={props.setSortValue}
            />
            {showPaginationComponent && (
              <FilterChips
                products={props.products}
                pageNo={props.pageNo}
                onFilterChange={props.onFilterChange}
                totalItems={props.totalItems}
                catalogDetails={props.catalogDetails}
                elementId={props.elementId}
                catalog={props.catalog}
                updateDataValue={props.updateDataValue}
                pageSize={webSettingsData?.defaultPageSize}
              />
            )}
          </div>
        </div>
        {/* {console.log("listView", props.listView)} */}
        <div className="row ">
          <div className="col-lg-12 pr-0 pl-0">
            {props.listView ? (
              <ProductList
                compareItems={props.compareItems}
                updateCompareListItems={props.updateCompareListItems}
                productList={productList}
                totalItems={props.totalItems}
                setListView={props.setListView}
                listView={props.listView}
                products={props.products}
                loading={props.loading}
                hasErrors={props.hasErrors}
                onAddToCartHandler={addItemToCartHandler}
                onAddItemToList={addItemToShoppingListHandler}
                onQuantityChangeHandler={quantityChangeHandler}
                onUnitChangeHandler={unitChangeHandler}
                catalog={props.catalog}
                onAddToCartActon={setShowAddToCart}
              />
            ) : (
              <ProductsGrid
                compareItems={props.compareItems}
                updateCompareListItems={props.updateCompareListItems}
                productList={productList}
                totalItems={props.totalItems}
                setListView={props.setListView}
                listView={props.listView}
                products={props.products}
                loading={props.loading}
                hasErrors={props.hasErrors}
                onAddToCartHandler={addItemToCartHandler}
                onAddItemToList={addItemToShoppingListHandler}
                onQuantityChangeHandler={quantityChangeHandler}
                onUnitChangeHandler={unitChangeHandler}
                catalog={props.catalog}
                onAddToCartActon={setShowAddToCart}
              />
            )}
            <AddItemToCart status={showAddToCart} onClose={setShowAddToCart} />
            <AddItemToShoppingList />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default MainContent;
